// extracted by mini-css-extract-plugin
export default {"notice":"NonIrishCountryNotice_notice__UDBvV","icon":"NonIrishCountryNotice_icon__Rht+Z","text":"NonIrishCountryNotice_text__119sl"};